export const quotationlistdata = [
  {
    id: "1",
    Product_image: "assets/img/products/stock-img-01.png",
    Product_Name: "Lenovo 3rd Generation",
    Custmer_Image: "assets/img/users/user-27.jpg",
    Custmer_Name: "Carl Evans",
    Status: "Sent",
    Total: "$550",
  },
  {
    id: "2",
    Product_image: "assets/img/products/stock-img-06.png",
    Product_Name: "Bold V3.2",
    Custmer_Image: "assets/img/users/user-02.jpg",
    Custmer_Name: "Minerva Rameriz",
    Status: "Sent",
    Total: "$430",
  },
  {
    id: "3",
    Product_image: "assets/img/products/stock-img-02.png",
    Product_Name: "Nike Jordan",
    Custmer_Image: "assets/img/users/user-05.jpg",
    Custmer_Name: "Robert Lamon",
    Status: "Ordered",
    Total: "$260",
  },
  {
    id: "4",
    Product_image: "assets/img/products/stock-img-03.png",
    Product_Name: "Apple Series 5 Watch",
    Custmer_Image: "assets/img/users/user-03.jpg",
    Custmer_Name: "Mark Joslyn",
    Status: "sent",
    Total: "$470",
  },
  {
    id: "5",
    Product_image: "assets/img/products/stock-img-04.png",
    Product_Name: "Amazon Echo Dot",
    Custmer_Image: "assets/img/users/user-22.jpg",
    Custmer_Name: "Patricia Lewis",
    Status: "Pending",
    Total: "$380",
  },
  {
    id: "6",
    Product_image: "assets/img/products/stock-img-05.png",
    Product_Name: "Lobar Handy",
    Custmer_Image: "assets/img/users/user-12.jpg",
    Custmer_Name: "Marsha Betts",
    Status: "Sent",
    Total: "$190",
  },
  {
    id: "7",
    Product_image: "assets/img/products/expire-product-01.png",
    Product_Name: "Red Premium Handy",
    Custmer_Image: "assets/img/users/user-06.jpg",
    Custmer_Name: "Daniel Jude",
    Status: "Pending",
    Total: "$540",
  },
  {
    id: "8",
    Product_image: "assets/img/products/expire-product-02.png",
    Product_Name: "Iphone 14 Pro",
    Custmer_Image: "assets/img/users/user-21.jpg",
    Custmer_Name: "Emma Bates",
    Status: "Ordered",
    Total: "$610",
  },
  {
    id: "9",
    Product_image: "assets/img/products/expire-product-03.png",
    Product_Name: "Black Slim 200",
    Custmer_Image: "assets/img/users/user-16.jpg",
    Custmer_Name: "Richard Fralick",
    Status: "Pending",
    Total: "$220",
  },
  {
    id: "10",
    Product_image: "assets/img/products/expire-product-04.png",
    Product_Name: "Woodcraft Sandal",
    Custmer_Image: "assets/img/users/user-26.jpg",
    Custmer_Name: "Michelle Robison",
    Status: "Sent",
    Total: "$460",
  },
  {
    id: "11",
    Product_image: "assets/img/products/expire-product-01.png",
    Product_Name: "Lobar Handy",
    Custmer_Image: "assets/img/users/user-03.jpg",
    Custmer_Name: "Mark Joslyn",
    Status: "Pending",
    Total: "$250",
  },
  {
    id: "12",
    Product_image: "assets/img/products/expire-product-02.png",
    Product_Name: "Iphone 15 Pro",
    Custmer_Image: "assets/img/users/user-05.jpg",
    Custmer_Name: "Robert Lamon",
    Status: "Sent",
    Total: "$550",
  },
];
